module.exports = __webpack_public_path__ + "img/project12_4.jpg.666ebd60.webp";